import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=1c65dd23"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports